// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + {"532":"styles","5972":"vendor-swiper"}[chunkId] + "." + {"532":"5dade2d45f370feffcec","5972":"3442d4ba13ef968e484b"}[chunkId] + ".css";
};